// This component is used as a fallback
// when page module or block editor component is not found
function Blank() {
  return null;
}

export { Blank };
